import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const fetchCityMasterData = createAsyncThunk(
  "cityMaster/fetchCityMasterData",
  async (cityName, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getallcitymaster,
        cityName
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
const getLocalStorageData = (key) => {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : null;
};
const cityMasterSlice = createSlice({
  name: "cityMaster",
  initialState: {
    cityData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCityMasterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCityMasterData.fulfilled, (state, action) => {
        state.loading = false;
        state.cityData = action.payload.data.map((item) => ({
          value: item.CITY,
          label: item.CITY,
        }));
      })
      .addCase(fetchCityMasterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cityMasterSlice.reducer;
